<template>
  <div id="app">
    <ClassSearch />
  </div>
</template>

<script>
import ClassSearch from "./components/ClassSearch.vue";

export default {
  name: "App",
  components: {
    ClassSearch,
  },
};
</script>

<style lang="scss">
body {
  font-family: "Microsoft YaHei", sans-serif;
  color: #4d5259;
  line-height: 1.72;
  font-size: 14px;
  overflow-x: hidden;
  padding: 0 30px;
}
</style>
